import { DECIMAL_PRECISION_MONETARY } from '../constants/index.js';

/**
 * Round to monetary precision (2 decimal places) with EPSILON nudge
 * to avoid floating point issues like 1.005 rounding to 1.00.
 */
export function roundMoney(value: number): number {
  const factor = Math.pow(10, DECIMAL_PRECISION_MONETARY);
  return Math.round((value + Number.EPSILON) * factor) / factor;
}

/**
 * Generate a UUID v4 for correlation IDs and event IDs.
 */
export function generateId(): string {
  return crypto.randomUUID();
}

/**
 * Clamp a number between min and max bounds.
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/**
 * Type-safe check if a value is not null/undefined.
 */
export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

/**
 * Sleep for a given number of milliseconds (useful for retry backoff).
 */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Chunk an array into smaller arrays of a given size.
 */
export function chunk<T>(array: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}
